import Vue from 'vue'
import Router from 'vue-router'
import VuePageTransition from 'vue-page-transition'

import Home from '@/components/Home'
import About from '@/components/About'
import Works from '@/components/Works'

import InternalFluctuaion from '@/components/Works-items/InternalFluctuation'
import Complement from '@/components/Works-items/Complement'
import Purification from '@/components/Works-items/Purification'
import DeJong from '@/components/Works-items/DeJong'

Vue.use(Router)
Vue.use(VuePageTransition)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/works',
      name: 'Works',
      component: Works
    },
    {
      // works-item
      path: '/internalFluctuation',
      name: 'InternalFluctuation',
      component: InternalFluctuaion
    },
    {
      // works-item
      path: '/complement',
      name: 'Complement',
      component: Complement
    },
    {
      // works-item
      path: '/purification',
      name: 'Purification',
      component: Purification
    },
    {
      // works-item
      path: '/deJong',
      name: 'DeJong',
      component: DeJong
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js